

function ProgressBar({ details:{width, fill, outerClassName, innerClassName, height} }) {

    return (
        <div className={outerClassName} style={{width:width, height:height, display:"inline-block", backgroundColor:"red", position:"relative"}}>
            <div className={innerClassName} style={{width:fill, height:"130%", display:"inline-block", backgroundColor:"rgba(31, 164, 226)", position:"absolute", top:"-1px", left:"0px", transition:"width .2s ease-out"}}></div>
        </div>
    );

}

export default ProgressBar;